function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

setTimeout(() => {
    for(let i=1;i<54;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/goslim_box3_${i}.avif?v=1768188335`;
    }
}, 3000);

setTimeout(() => {
    for(let i=1;i<41;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/goslim_nbox7_${i}.avif?v=1769497403`;
    }
}, 6000);
 
var wFlag=window.innerWidth>750

$(()=>{
    //box2
    showUp('.box2_title')
    ScrollTrigger.create({
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })
    
    //box3
    showUp('.box3_title')
    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top top+=6%':'top top+=10%',
        end:'+=100%',
        //markers:true,
        scrub:1,
        pin:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 52);
            $('.box3_img').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/goslim_box3_${index+1}.avif?v=1768188335`)
        }
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:wFlag?'top+=20% top+=6%':'top+=20% top+=10%',
            end:'+=80%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box3_items div',{opacity:0,y:'2rem',stagger:0.2})
        })
    }
    
    //box4
    ScrollTrigger.create({
        trigger:'.box4',
        start:'top top+=40%',
        end:'+=30%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box4_mask img',{opacity:0})
    })

    ScrollTrigger.create({
        trigger:'.box4',
        start:wFlag?'top+=5% top':'top top+=12%',
        end:'+=40%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to('.box4_mask img',{scale:15})
            .to('.box4_mask',{opacity:0},'-=95%')
            .to({},{duration:0.2})
    })
    
    //box5
    gsap.timeline()
    .to('.box5_line div:first-child',{x:'-100%',duration:8,ease:'none',repeat:-1})
    .to('.box5_line div:last-child',{x:'0%',duration:8,ease:'none',repeat:-1},'<')
    showUp('.box5_info')
    showUp('.box5_img')

    ScrollTrigger.create({
        trigger:'.box5',
        start:'top+=0% top',
        end:'+=150%',
        scrub:1,
        animation:gsap.timeline()
            .to('.box5_bg',{y:'20%'})
    })
    
    //box6
    showUp('.box6_title')
    
    //box7
    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7',
        start:wFlag?'top+=10% top':'top top+=10%',
        end:'+=50%',
        //markers:true,
        scrub:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 39);
            $('.box7_img').attr('src', `https://cdn.shopify.com/s/files/1/0584/6709/0582/files/goslim_nbox7_${index+1}.avif?v=1769497403`)
        },
        animation:gsap.timeline()
            .to('.box7_img',{x:wFlag?'36%':'32%',y:wFlag?'74%':'80%'})
    })
    
    //box8
    showUp('.box8_title')

    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')
})